module.exports = __webpack_public_path__ + "static/media/preview.bb95d072.png";